export const env = {
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID as string,
  apiUrl: import.meta.env.VITE_API_URL as string,
};

if (!env.googleClientId || !env.apiUrl) {
  throw new Error("VITE_GOOGLE_CLIENT_ID ou VITE_API_URL não definida no .env");
}
